export enum Domain {
    ACKO = 'acko',
    ACKODRIVE = 'ackodrive',
}
